var render = function render() {
    var _vm = this,
        _c = _vm._self._c;return _c('frame-sequence', _vm._b({}, 'frame-sequence', {
        images: _vm.images,
        frameSequenceStyle: _vm.frameSequenceStyle,
        frameSequenceContainerStyle: _vm.frameSequenceContainerStyle,
        initKeyFramesOnMounted: _vm.initKeyFramesOnMounted
    }, false), [_vm.fileMeta ? _c('file-meta', _vm._b({ attrs: { "customStyle": _vm.fileMetaStyle } }, 'file-meta', _vm.fileMeta, false)) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };